import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.editOnFullscreen &&
    (_vm.form.show ||
      [_vm.addFormRouteName, _vm.editFormRouteName].includes(_vm.$route.name))
    ? _c(
        VContainer,
        [
          _c(
            VRow,
            { key: _vm.form.key },
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VCard,
                    [
                      _c(
                        VCardTitle,
                        [
                          _vm._t("edit-form-title", function () {
                            return [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$route.params.action || _vm.formInfo.id
                                      ? "Edit"
                                      : "Add"
                                  ) +
                                  " Form\n          "
                              ),
                            ]
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        VCardText,
                        [
                          _vm.formDefData
                            ? _c(
                                "AtForm",
                                _vm._b(
                                  {
                                    attrs: { def: _vm.formDefData },
                                    on: {
                                      onCancel: _vm.onFormCancel,
                                      onSubmit: _vm.onFormSubmit,
                                    },
                                    model: {
                                      value: _vm.formInfo,
                                      callback: function ($$v) {
                                        _vm.formInfo = $$v
                                      },
                                      expression: "formInfo",
                                    },
                                  },
                                  "AtForm",
                                  _vm.childComputed.form.props,
                                  false
                                )
                              )
                            : _c(
                                "div",
                                [
                                  _vm._v(
                                    "\n            formDefData Not defined\n            "
                                  ),
                                  _c(
                                    VBtn,
                                    { on: { click: _vm.onFormCancel } },
                                    [
                                      _vm._v(
                                        "\n              Close\n            "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c(
        VContainer,
        [
          _c(VRow, [_vm._t("title")], 2),
          _vm._v(" "),
          _c(
            VDialog,
            _vm._b(
              {
                key: _vm.form.key,
                attrs: { fullscreen: _vm.$vuetify.breakpoint.xs },
                model: {
                  value: _vm.form.show,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "show", $$v)
                  },
                  expression: "form.show",
                },
              },
              "v-dialog",
              _vm.childComputed.dialog.props,
              false
            ),
            [
              _c(
                VCard,
                [
                  _c(
                    VCardTitle,
                    [
                      _vm._t(
                        "dialog-title",
                        function () {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.formInfo.id ? "Edit" : "Add") +
                                " Form\n        "
                            ),
                          ]
                        },
                        { formInfo: _vm.formInfo }
                      ),
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c(
                    VCardText,
                    [
                      _vm.formDefData
                        ? _c(
                            "AtForm",
                            _vm._b(
                              {
                                attrs: { def: _vm.formDefData },
                                on: {
                                  onCancel: _vm.onFormCancel,
                                  onSubmit: _vm.onFormSubmit,
                                },
                                model: {
                                  value: _vm.formInfo,
                                  callback: function ($$v) {
                                    _vm.formInfo = $$v
                                  },
                                  expression: "formInfo",
                                },
                              },
                              "AtForm",
                              _vm.childComputed.form.props,
                              false
                            )
                          )
                        : _c(
                            "div",
                            [
                              _vm._v(
                                "\n          formDefData Not defined\n          "
                              ),
                              _c(VBtn, { on: { click: _vm.onFormCancel } }, [
                                _vm._v("\n            Close\n          "),
                              ]),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(VRow, [_vm._t("title")], 2),
          _vm._v(" "),
          _c(
            VRow,
            [
              _vm._t(
                "top",
                function () {
                  return [
                    _c(VSpacer),
                    _vm._v(" "),
                    _vm.topActionList.includes("showFilter")
                      ? _c(
                          VCol,
                          { attrs: { cols: "auto" } },
                          [
                            _c("ActionButton", {
                              attrs: {
                                preset: _vm.showFilter
                                  ? "hideFilter"
                                  : "showFilter",
                                text: "",
                                dark: false,
                                "badge-content":
                                  _vm.activeFilterInputsNumber.toString(),
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.toggleShowFilter()
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.topActionList.includes("add")
                      ? _c(
                          VCol,
                          { attrs: { cols: "auto" } },
                          [
                            _vm.editOnFullscreen && _vm.addFormRouteName
                              ? _c(
                                  "ActionButton",
                                  _vm._b(
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push({
                                            name: _vm.addFormRouteName,
                                          })
                                        },
                                      },
                                    },
                                    "ActionButton",
                                    _vm.childComputed.addBtn.props,
                                    false
                                  )
                                )
                              : _c(
                                  "ActionButton",
                                  _vm._b(
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.showForm(null)
                                        },
                                      },
                                    },
                                    "ActionButton",
                                    _vm.childComputed.addBtn.props,
                                    false
                                  )
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                },
                null,
                {
                  showForm: _vm.showForm,
                  toggleShowFilter: _vm.toggleShowFilter,
                  activeFilterInputsNumber: _vm.activeFilterInputsNumber,
                  topActionList: _vm.topActionList,
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            VRow,
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.showFilter && !_vm.isSearchDefEmpty,
                  expression: "showFilter && !isSearchDefEmpty",
                },
              ],
            },
            [
              _c(
                VCol,
                [
                  _c(
                    VCard,
                    { staticClass: "px-3 py-5" },
                    [
                      _c(
                        "AtForm",
                        _vm._b(
                          {
                            attrs: {
                              def: _vm.searchDefData,
                              "undefined-on-empty": "",
                            },
                            on: {
                              onSubmit: _vm.onSubmit,
                              activeInputsNumber: function ($event) {
                                _vm.activeFilterInputsNumber = $event
                              },
                            },
                            model: {
                              value: _vm.searchInfo,
                              callback: function ($$v) {
                                _vm.searchInfo = $$v
                              },
                              expression: "searchInfo",
                            },
                          },
                          "AtForm",
                          _vm.childComputed.search.props,
                          false
                        )
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            VRow,
            [
              _c(
                VCol,
                [
                  _c(
                    "AtDataTable",
                    _vm._g(
                      _vm._b(
                        {
                          attrs: {
                            cols: _vm.tableDefData,
                            rows: _vm.rows,
                            loading: _vm.loading,
                          },
                          on: { search: _vm.dataTableEvent },
                          scopedSlots: _vm._u(
                            [
                              _vm._l(_vm.tableDefData, function (header) {
                                return {
                                  key: `header_${header.value}`,
                                  fn: function () {
                                    return [
                                      _vm._t(
                                        "table_header_" + header.value,
                                        function () {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(header.text) +
                                                "\n          "
                                            ),
                                          ]
                                        },
                                        { header: header }
                                      ),
                                    ]
                                  },
                                  proxy: true,
                                }
                              }),
                              _vm._l(_vm.tableDefData, function (header) {
                                return {
                                  key: `item_${header.value}`,
                                  fn: function ({ item }) {
                                    return [
                                      _vm._t(
                                        "table_item_" + header.value,
                                        function () {
                                          return [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(item[header.value]) +
                                                "\n          "
                                            ),
                                          ]
                                        },
                                        { item: item, showForm: _vm.showForm }
                                      ),
                                    ]
                                  },
                                }
                              }),
                              {
                                key: "expanded_item",
                                fn: function (data) {
                                  return [
                                    _vm._t(
                                      "table_row_expanded",
                                      null,
                                      null,
                                      data
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: _vm.options,
                            callback: function ($$v) {
                              _vm.options = $$v
                            },
                            expression: "options",
                          },
                        },
                        "AtDataTable",
                        _vm.childComputed.dataTable.props,
                        false
                      ),
                      _vm.childComputed.dataTable.on
                    )
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }